import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["2xs", "3xs"],
    },
  },
});

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));